(function () {
  'use strict';

  var config = window.NSGiftCampaignConfig || {};
  if (!config.enabled || window.__nsGiftCampaignLoaded) return;
  window.__nsGiftCampaignLoaded = true;

  var busy = false;
  var queued = false;
  var timer = null;
  var lastTrigger = 'load';
  var progressClosed = false;
  var progressExplicitlyOpened = false;
  function defaultCompactProgress() { return config.pageType !== 'cart' && window.matchMedia && window.matchMedia('(max-width: 699px)').matches; }
  var lastProgressLevel = null;
  var productEntryTimer = null;
  var latestCart = null;
  var closedCartState = '';
  try { closedCartState = sessionStorage.getItem('ns_dueling_progress_closed') || ''; } catch (error) {}
  var originalFetch = window.fetch.bind(window);
  var privateProperty = '_ns_gift_campaign';
  var rewardChoice = null;
  var restoringReward = false;
  var restoreFeedback = '';
  var cartViewRevision = 0;
  try { rewardChoice = JSON.parse(sessionStorage.getItem('ns_dueling_reward_choice') || 'null'); } catch (error) {}

  function rewardDeclined(cart) {
    return Boolean(rewardChoice && rewardChoice.token === String(cart.token || 'cart') &&
      rewardChoice.level === progressLevelFor(eligibleSpendSubtotal(cart)) && rewardChoice.declined);
  }

  // Compare confirmed cart snapshots, never an intermediate remove/add response
  // from our own tier replacement. A changed tier starts a new reward choice.
  function rememberRewardCart(cart, detectRemoval) {
    var token = String(cart.token || 'cart');
    var level = progressLevelFor(eligibleSpendSubtotal(cart));
    var gift = spendReward(cart);
    var present = gift && (cart.items || []).some(function (item) {
      return isOwnCampaignGift(item) && Number(item.variant_id) === Number(gift.variantId);
    });
    var sameTier = rewardChoice && rewardChoice.token === token && rewardChoice.level === level;
    // Another tab may have restored the gift. Its confirmed presence takes
    // precedence over this tab's stale "declined" choice.
    var declined = Boolean(sameTier && !present && (rewardChoice.declined || (detectRemoval && rewardChoice.present)));
    rewardChoice = { token: token, level: level, present: Boolean(present), declined: declined };
    try { sessionStorage.setItem('ns_dueling_reward_choice', JSON.stringify(rewardChoice)); } catch (error) {}
  }

  function root() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function cartRequest(path, options) {
    return originalFetch(root() + path, options).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (payload) {
        if (!response.ok) throw new Error(payload.description || payload.message || 'Gift campaign cart update failed.');
        return Array.isArray(payload.items) && typeof payload.item_count === 'number' && window.NSLiveEligibility ? window.NSLiveEligibility.cart(payload) : payload;
      });
    });
  }

  function property(item, name) {
    return item && item.properties ? item.properties[name] : null;
  }

  // Migrate existing carts that still carry the old paid-add-on GWP tag.
  // Leave all actual gifts, prices, quantities and other properties untouched.
  function normalizePaidProtection(cart, attempts) {
    var line = (cart.items || []).find(function (item) {
      return [47412493615321, 46318566899929].indexOf(Number(item.variant_id)) !== -1 &&
        Number(item.final_line_price) > 0 &&
        (String(property(item, '_widget_id') || '') === '281651' ||
          /gift with purchase/i.test(String(property(item, '_attribution') || '')));
    });
    if (!line) return Promise.resolve(cart);
    if ((attempts || 0) >= 4) return Promise.reject(new Error('Paid protection could not be verified. Please refresh your cart.'));
    var properties = Object.assign({}, line.properties, { _auto_restored: 'true' });
    delete properties._widget_id;
    delete properties._attribution;
    delete properties._source;
    return cartRequest('cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: properties })
    }).then(function (updated) {
      return normalizePaidProtection(updated, (attempts || 0) + 1);
    }).then(function (updated) {
      refreshThemeCart();
      return updated;
    });
  }

  function isOwnCampaignGift(item) {
    return Boolean(property(item, privateProperty));
  }

  function isLegacyGift(item) {
    return property(item, '_B1G2 gift') === 'true' ||
      property(item, '_B1G3 gift') === 'true' ||
      property(item, '_NS promotion gift') === 'true';
  }

  function isLegacyOfferItem(item) {
    return property(item, '_B1G2 offer') === 'true' ||
      property(item, '_B1G3 offer') === 'true' ||
      property(item, '_NS promotion offer') === 'true';
  }

  function isAnyGiftLine(item) {
    return isOwnCampaignGift(item) || isLegacyGift(item);
  }

  function isReservedGiftVariant(item) {
    if (!item) return false;
    var reservedIds = spendTiers()
      .map(function (tier) { return Number(String(tier.variant_id || '').split('/').pop()); })
      .filter(function (variantId) { return variantId > 0; });
    return reservedIds.indexOf(Number(item.variant_id || 0)) !== -1;
  }

  function eligibleSpendSubtotal(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      if (isAnyGiftLine(item) || isReservedGiftVariant(item) || isLegacyOfferItem(item) || isExcludedPromotionProduct(item) || item.selling_plan_allocation) return sum;
      return sum + Number((config.automaticDiscount ? item.original_line_price : item.final_line_price) || 0);
    }, 0);
  }

  function isExcludedPromotionProduct(item) {
    var excludedIds = config.spend && config.spend.excludedProductIds || [];
    var id = Number(item && item.product_id || 0);
    var eligible = config.spend && config.spend.eligibleProductIds;
    return excludedIds.map(Number).indexOf(id) !== -1 || (Array.isArray(eligible) && eligible.map(Number).indexOf(id) === -1);
  }

  function formatMoney(cents, exact) {
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: config.currency || 'USD',
        minimumFractionDigits: exact ? 2 : 0,
        maximumFractionDigits: exact ? 2 : 0
      }).format(Math.max(0, Number(cents || 0)) / 100);
    } catch (error) {
      return '$' + Math.round(Math.max(0, Number(cents || 0)) / 100);
    }
  }

  function currencyRate() {
    var rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate || 1);
    return Number.isFinite(rate) && rate > 0 ? rate : 1;
  }

  function spendTiers() {
    if (Array.isArray(config.spend.tiers)) return config.spend.tiers;
    return ['one', 'two', 'four'].map(function (key, i) {
      return {threshold_cents: Number(config.spend[['tierOne','tierTwo','tierThree'][i]] || [29900,39900,69900][i]), saber_count: [1,2,4][i], variant_id: String(((config.gifts || {})[key] || {}).variantId || 0)};
    });
  }

  function spendThresholds() {
    var rate = currencyRate();
    return spendTiers().map(function (tier) { return Math.round(Number(tier.threshold_cents) * rate); });
  }

  function rewardCount(level) { return Number((spendTiers()[level - 1] || {}).saber_count || 0); }
  function rewardLabel(level) { var count = rewardCount(level); return count + ' FREE Dueling Saber' + (count === 1 ? '' : 's'); }
  function giftForTier(level) {
    var gift = (config.gifts || {})['tier-' + level] || (config.gifts || {})[['one','two','four'][level - 1]];
    var tier = spendTiers()[level - 1];
    return tier && gift && String(gift.variantId) === String(tier.variant_id).split('/').pop() ? gift : null;
  }

  function progressLevelFor(subtotal) {
    var thresholds = spendThresholds();
    return thresholds.reduce(function (level, threshold, i) { return subtotal >= threshold ? i + 1 : level; }, 0);
  }

  function progressStatus(subtotal) {
    var level = progressLevelFor(subtotal);
    if (!level) return 'Your next saber could be FREE.';
    var count = rewardCount(level);
    return 'Congrats! ' + count + ' FREE Dueling Saber' + (count === 1 ? '' : 's') + ' unlocked.';
  }

  function nextRewardMessage(subtotal) {
    var level = progressLevelFor(subtotal);
    if (level === spendTiers().length) return 'Top reward unlocked — ' + rewardLabel(level) + '!';
    var remaining = Math.max(0, spendThresholds()[level] - subtotal);
    return 'Add ' + formatMoney(remaining, remaining % 100 !== 0) + ' more to unlock ' + rewardLabel(level + 1) + '.';
  }

  // Rebuild only when rules change, not on every cart update. Never rebind ATC.
  function ensureTierDisplay() {
    var tiers = spendTiers(), signature = JSON.stringify(tiers.map(function (t) { return [t.threshold_cents, t.saber_count]; }));
    var headline = document.querySelector('[data-ns-spend-maximum-count]');
    if (headline) headline.textContent = String(Math.max.apply(Math, tiers.map(function (t) { return Number(t.saber_count); }).concat([0])));
    [['.ns-gift-progress__tiers','data-ns-gift-progress-tier-value','data-ns-gift-progress-tier','[data-ns-gift-progress-meter]','data-ns-gift-progress-marker'],['.ns-spend-shop__tiers','data-ns-spend-page-tier',null,'[data-ns-spend-page-meter]','data-ns-spend-page-marker']].forEach(function (spec) {
      var list = document.querySelector(spec[0]), meter = document.querySelector(spec[3]);
      if (!list || list.dataset.nsTierSignature === signature) return;
      var cards = [], markers = [];
      tiers.forEach(function (t, i) {
        var card = document.createElement('div'), price = document.createElement('strong'), label = document.createElement('span'), marker = document.createElement('span');
        if (spec[2]) { card.className = 'ns-gift-progress__tier'; card.setAttribute(spec[2], String(i + 1)); }
        price.setAttribute(spec[1], String(i + 1)); price.textContent = formatMoney(spendThresholds()[i]);
        label.textContent = rewardLabel(i + 1); card.append(price, label); cards.push(card);
        marker.className = 'ns-gift-progress__marker'; marker.setAttribute(spec[4], String(i + 1)); marker.setAttribute('aria-hidden','true');
        marker.style.setProperty('--ns-gift-stop', (Number(t.threshold_cents) / Number(tiers[tiers.length - 1].threshold_cents) * 100) + '%'); markers.push(marker);
      });
      list.replaceChildren.apply(list, cards); list.dataset.nsTierSignature = signature;
      list.classList.toggle('has-many-tiers', tiers.length > 3);
      if (meter) { meter.querySelectorAll('.ns-gift-progress__marker').forEach(function (m) { m.remove(); }); markers.forEach(function (m) { meter.appendChild(m); }); }
    });
  }

  function setRewardBrightness(meter, level) {
    // Preserve the established three-tier glow; scale additional tiers smoothly.
    var ratio = level / Math.max(1, spendTiers().length), fill = meter.querySelector('.ns-gift-progress__fill');
    if (!fill) return;
    if (spendTiers().length === 3) { fill.style.removeProperty('opacity'); fill.style.removeProperty('box-shadow'); return; }
    fill.style.opacity = String(level ? .7 + .3 * ratio : .55);
    fill.style.boxShadow = '0 0 ' + (1 + 6 * ratio) + 'px #fff, 0 0 ' + (4 + 12 * ratio) + 'px rgba(var(--ns-gift-accent-rgb),1), 0 0 ' + (8 + 26 * ratio) + 'px rgba(var(--ns-gift-accent-rgb),.8)';
  }

  function shoppingUrl() {
    var url = config.shopUrl || root() + 'collections/all?view=spend-more';
    if (window.Shopify && window.Shopify.theme && window.Shopify.theme.role !== 'main') {
      url += '&preview_theme_id=' + window.Shopify.theme.id;
    }
    return url;
  }

  function progressState(cart) {
    return String(cart.token || 'cart') + ':' + progressLevelFor(eligibleSpendSubtotal(cart));
  }

  function updateShoppingLinks() {
    ensureTierDisplay();
    document.querySelectorAll('[data-ns-gift-shop]').forEach(function (link) {
      link.href = shoppingUrl();
    });
    document.querySelectorAll('[data-ns-spend-page-tier]').forEach(function (node) {
      node.textContent = formatMoney(spendThresholds()[Number(node.getAttribute('data-ns-spend-page-tier')) - 1]);
    });
  }

  function setProgressVisibility(open) {
    var panel = document.querySelector('[data-ns-gift-progress]');
    var launcher = document.querySelector('[data-ns-gift-progress-open]');
    if (panel) panel.hidden = !open;
    if (launcher) launcher.hidden = open;
  }

  function renderShoppingProgress(subtotal) {
    ensureTierDisplay();
    var meter = document.querySelector('[data-ns-spend-page-meter]');
    if (!meter) return;
    var thresholds = spendThresholds();
    if (!thresholds.length) return;
    var maximum = thresholds[thresholds.length - 1];
    var fill = document.querySelector('[data-ns-spend-page-fill]');
    var total = document.querySelector('[data-ns-spend-page-total]');
    var gapLabel = document.querySelector('[data-ns-spend-page-gap-label]');
    var gapAmount = document.querySelector('[data-ns-spend-page-gap]');
    var goal = document.querySelector('[data-ns-spend-page-goal]');
    var level = progressLevelFor(subtotal);
    var top = level === thresholds.length;
    var remaining = !top ? Math.max(0, thresholds[level] - subtotal) : 0;
    if (fill) fill.style.width = Math.min(100, Math.max(0, subtotal / maximum * 100)) + '%';
    if (total) total.textContent = 'Your eligible total: ' + formatMoney(subtotal, true);
    if (gapLabel) gapLabel.textContent = top ? 'TOP REWARD UNLOCKED' : subtotal > 0 && remaining <= thresholds[level] * 0.15 ? 'YOU’RE SO CLOSE — ADD JUST' : 'YOUR NEXT FREE REWARD — ADD';
    if (gapAmount) gapAmount.textContent = top ? rewardLabel(level) : formatMoney(remaining, remaining % 100 !== 0) + ' more';
    if (goal) goal.textContent = top ? 'Congrats! You’ve reached the highest reward.' : 'to unlock ' + rewardLabel(level + 1) + '.';
    meter.setAttribute('aria-valuemax', String(maximum / 100));
    meter.setAttribute('aria-valuenow', String(Math.min(maximum, Math.max(0, subtotal)) / 100));
    meter.setAttribute('data-reward-level', String(level));
    setRewardBrightness(meter, level);
    meter.setAttribute('aria-valuetext', formatMoney(subtotal, true) + ' eligible spend. ' + nextRewardMessage(subtotal));
    thresholds.forEach(function (threshold, index) {
      var value = document.querySelector('[data-ns-spend-page-tier="' + (index + 1) + '"]');
      var marker = document.querySelector('[data-ns-spend-page-marker="' + (index + 1) + '"]');
      if (value) {
        value.textContent = formatMoney(threshold);
        if (value.parentElement) value.parentElement.classList.toggle('is-unlocked', subtotal >= threshold);
      }
      if (marker) {
        marker.style.setProperty('--ns-gift-stop', (threshold / maximum * 100) + '%');
        marker.classList.toggle('is-unlocked', subtotal >= threshold);
      }
    });
  }

  function renderProgress(cart, trigger) {
    var panel = document.querySelector('[data-ns-gift-progress]');
    var launcher = document.querySelector('[data-ns-gift-progress-open]');
    latestCart = cart;
    var subtotal = eligibleSpendSubtotal(cart);
    renderShoppingProgress(subtotal);
    if (!panel || document.querySelector('.ns-spend-shop') || !config.showProgress || !config.spend || !config.spend.enabled || subtotal <= 0 || (config.productEntry && !productEntryEligible())) {
      if (panel) panel.hidden = true;
      if (launcher) launcher.hidden = true;
      lastProgressLevel = null;
      return;
    }

    var thresholds = spendThresholds();
    var maximum = thresholds[thresholds.length - 1];
    var progressLevel = progressLevelFor(subtotal);
    if (lastProgressLevel === null) progressClosed = closedCartState === progressState(cart) || (defaultCompactProgress() && !progressExplicitlyOpened);
    else if (progressLevel !== lastProgressLevel) progressClosed = defaultCompactProgress() && !progressExplicitlyOpened;
    lastProgressLevel = progressLevel;
    var progress = Math.min(100, Math.max(0, (subtotal / maximum) * 100));
    var status = panel.querySelector('[data-ns-gift-progress-status]');
    var eligibleTotal = panel.querySelector('[data-ns-gift-progress-total]');
    if (eligibleTotal) eligibleTotal.textContent = 'Eligible paid total: ' + formatMoney(subtotal, true);
    var fill = panel.querySelector('[data-ns-gift-progress-fill]');
    var meter = panel.querySelector('[data-ns-gift-progress-meter]');
    var rewards = desiredRewards(cart);
    var ready = progressLevel > 0 && rewardLinesAreFree(cart, rewards) && rewards.length > 0;
    var declined = rewardDeclined(cart);
    if (status) status.textContent = restoringReward ? 'Adding your FREE gift back…' : declined ? 'Your free gift was removed.' : progressLevel && !rewards.length ? 'Your reward is temporarily unavailable.' : progressLevel && !ready ? 'Getting your FREE sabers ready…' : progressStatus(subtotal);
    var rewardBox = panel.querySelector('[data-ns-gift-progress-reward]');
    var savings = panel.querySelector('[data-ns-gift-progress-savings]');
    var next = panel.querySelector('[data-ns-gift-progress-next]');
    if (rewardBox) rewardBox.hidden = !ready;
    if (savings && ready) {
      var rewardLine = (cart.items || []).find(function (item) { return isOwnCampaignGift(item) && Number(item.variant_id) === rewards[0].variantId; });
      var saved = rewardLine ? Number(rewardLine.original_line_price || 0) - Number(rewardLine.final_line_price || 0) : 0;
      savings.textContent = saved > 0 ? 'You saved ' + formatMoney(saved, true) + ' on your gift' : 'Your Dueling Sabers are FREE';
    }
    var restoreButton = panel.querySelector('[data-ns-gift-restore]');
    var restoreMessage = panel.querySelector('[data-ns-gift-restore-message]');
    var canRestore = declined && Boolean(spendReward(cart));
    if (restoreButton) {
      restoreButton.hidden = !restoringReward && !canRestore;
      restoreButton.disabled = restoringReward;
      restoreButton.textContent = restoringReward ? 'Adding FREE gift…' : 'Add my FREE gift back';
      restoreButton.setAttribute('aria-busy', String(restoringReward));
    }
    if (restoreMessage) {
      restoreMessage.hidden = !restoreFeedback;
      restoreMessage.textContent = restoreFeedback;
    }
    if (next) next.textContent = declined ? (canRestore ? 'You’re still eligible. Add your FREE gift back whenever you’re ready.' : 'Your gift is currently unavailable. Please contact us for help.') : progressLevel && !rewards.length ? 'Please contact us before checkout so we can help with your gift.' : nextRewardMessage(subtotal);
    panel.classList.toggle('has-reward', ready);
    if (launcher) launcher.setAttribute('aria-label', (declined ? 'Your free gift was removed.' : progressStatus(subtotal)) + ' View rewards');
    if (fill) fill.style.width = progress + '%';
    if (meter) {
      meter.setAttribute('aria-valuemax', String(maximum / 100));
      meter.setAttribute('aria-valuenow', String(Math.min(maximum, Math.max(0, subtotal)) / 100));
      meter.setAttribute('data-reward-level', String(progressLevel));
      setRewardBrightness(meter, progressLevel);
      meter.setAttribute('aria-valuetext', progressStatus(subtotal));
    }

    thresholds.forEach(function (threshold, index) {
      var tierNumber = index + 1;
      var tier = panel.querySelector('[data-ns-gift-progress-tier="' + tierNumber + '"]');
      var marker = panel.querySelector('[data-ns-gift-progress-marker="' + tierNumber + '"]');
      var value = panel.querySelector('[data-ns-gift-progress-tier-value="' + tierNumber + '"]');
      var unlocked = subtotal >= threshold;
      if (tier) tier.classList.toggle('is-unlocked', unlocked);
      if (marker) {
        marker.classList.toggle('is-unlocked', unlocked);
        marker.style.setProperty('--ns-gift-stop', (threshold / maximum * 100) + '%');
      }
      if (value) value.textContent = formatMoney(threshold);
    });

    setProgressVisibility(!progressClosed);
  }

  function productEntryEligible() {
    var entry = config.productEntry;
    if (!entry || !entry.productId || !config.spend || !config.spend.enabled) return false;
    var blockedHandles = [
      'bogo-free-saber-copy', '2-free-dueling-sabers', '4-free-dueling-sabers',
      '2-free-sabers-gift', 'bogo-free-saber',
      'free-luke-v1', 'free-darksaber'
    ];
    if (blockedHandles.indexOf(String(entry.handle || '').toLowerCase()) !== -1) return false;
    return !isExcludedPromotionProduct({ product_id: entry.productId });
  }

  function mainProductForm() {
    var supplement = document.querySelector('ns-ani-desktop-fill:not([hidden])');
    var mainRerender = supplement && supplement.closest('product-rerender[observe-form]');
    var observedForm = mainRerender && document.getElementById(mainRerender.getAttribute('observe-form'));
    if (observedForm && observedForm.matches('form[action*="/cart/add"]')) return observedForm;
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
    return forms.find(function (form) { return String(form.id || '').indexOf('product-form-main-') === 0; }) ||
      forms.find(function (form) { return !form.closest('[id*="quick-buy"], quick-buy-modal, .quick-buy-modal'); }) || null;
  }

  function productFormItem(form, checkoutToken) {
    if (!form || !form.matches('form[action*="/cart/add"]')) throw new Error('The product form could not be found. Please refresh and try again.');
    var data = new FormData(form);
    var id = Number(data.get('id'));
    var quantity = Math.max(1, Number(data.get('quantity') || 1));
    if (!id) throw new Error('Please select an available product option first.');
    var properties = {};
    data.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== '') properties[match[1]] = value;
    });
    if (checkoutToken) properties['_ns_fast_checkout'] = checkoutToken;
    var item = { id: id, quantity: quantity };
    if (Object.keys(properties).length) item.properties = properties;
    var sellingPlan = data.get('selling_plan');
    if (sellingPlan) item.selling_plan = Number(sellingPlan);
    return item;
  }

  function removeFastCheckoutItem(cart, checkoutToken) {
    var updates = {};
    (cart.items || []).forEach(function (item) {
      if (item.properties && item.properties['_ns_fast_checkout'] === checkoutToken) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return Promise.resolve(cart);
    return cartRequest('cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () { return cartRequest('cart.js'); });
  }

  function ensureProductEntry() {
    var existing = document.querySelector('[data-ns-gift-product-entry]');
    if (existing) existing.remove();
    updateShoppingLinks();
  }

  function scheduleProductEntry() {
    window.clearTimeout(productEntryTimer);
    productEntryTimer = window.setTimeout(function () { ensureProductEntry(); }, 40);
  }

  function validGift(gift) {
    return Boolean(gift && gift.available && Number(gift.variantId) > 0);
  }

  function managedDiscountCodes() {
    return Object.keys(config.discountCodes || {})
      .map(function (key) { return String(config.discountCodes[key] || '').trim().toUpperCase(); })
      .concat(config.retiredDiscountCodes || [])
      .filter(Boolean);
  }

  function cartDiscountCodes(cart) {
    return (cart.discount_codes || [])
      .map(function (discount) { return String(discount && discount.code || '').trim(); })
      .filter(Boolean);
  }

  function rewardDiscountCodes(rewards) {
    if (config.automaticDiscount) return [];
    return rewards
      .map(function (reward) { return String(reward.discountCode || '').trim(); })
      .filter(Boolean);
  }

  function mergedDiscountCodes(cart, rewards) {
    var managed = managedDiscountCodes();
    var result = cartDiscountCodes(cart).filter(function (code) {
      return managed.indexOf(code.toUpperCase()) === -1;
    });
    rewardDiscountCodes(rewards).forEach(function (code) {
      if (result.map(function (value) { return value.toUpperCase(); }).indexOf(code.toUpperCase()) === -1) result.push(code);
    });
    return result;
  }

  function managedCodesMatch(cart, rewards) {
    var managed = managedDiscountCodes();
    var current = cartDiscountCodes(cart)
      .map(function (code) { return code.toUpperCase(); })
      .filter(function (code) { return managed.indexOf(code) !== -1; })
      .sort();
    var desired = rewardDiscountCodes(rewards)
      .map(function (code) { return code.toUpperCase(); })
      .sort();
    return current.join('|') === desired.join('|');
  }

  function applyManagedDiscountCodes(cart, rewards) {
    var previewMissing = config.previewBackend && (!cart.attributes || cart.attributes._ns_promotion_preview !== 'unified-v2');
    if (managedCodesMatch(cart, rewards) && !previewMissing) return Promise.resolve({ cart: cart, changed: false });
    return cartRequest('cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Object.assign({ discount: mergedDiscountCodes(cart, rewards).join(',') }, previewMissing ? {attributes:{_ns_promotion_preview:'unified-v2'}} : {}))
    }).then(function (updatedCart) {
      if (updatedCart && Array.isArray(updatedCart.items)) return { cart: updatedCart, changed: true };
      return cartRequest('cart.js').then(function (freshCart) {
        return { cart: freshCart, changed: true };
      });
    });
  }

  function rewardLinesAreFree(cart, rewards) {
    return rewards.every(function (reward) {
      var line = (cart.items || []).find(function (item) {
        return item.properties &&
          item.properties[privateProperty] === reward.campaign &&
          Number(item.variant_id) === Number(reward.variantId);
      });
      return Boolean(line) &&
        Number(line.quantity) === Number(reward.quantity) &&
        Number(line.final_line_price || 0) === 0;
    });
  }

  function removeCampaignRewardLines(cart) {
    var updates = {};
    (cart.items || []).forEach(function (item) {
      if (item.properties && item.properties[privateProperty]) updates[item.key] = 0;
    });
    var sequence = Promise.resolve(cart);
    if (Object.keys(updates).length) {
      sequence = cartRequest('cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () { return cartRequest('cart.js'); });
    }
    return sequence.then(function (updatedCart) {
      return applyManagedDiscountCodes(updatedCart, []).then(function (result) { return result.cart; });
    });
  }

  function spendReward(cart) {
    if (!config.spend || !config.spend.enabled) return null;
    var level = progressLevelFor(eligibleSpendSubtotal(cart));
    if (!level) return null;
    var gift = giftForTier(level);
    if (!validGift(gift)) return null;
    return {
      campaign: 'spend',
      tier: 'tier-' + level,
      variantId: Number(gift.variantId),
      quantity: 1,
      saberCount: rewardCount(level),
      signature: 'dueling-tier-' + level,
      discountCode: config.discountCodes && config.discountCodes[['tierOne', 'tierTwo', 'tierThree'][level - 1]],
      label: 'Spend More — ' + rewardLabel(level),
      title: progressStatus(eligibleSpendSubtotal(cart)),
      message: nextRewardMessage(eligibleSpendSubtotal(cart))
    };
  }

  function desiredRewards(cart) {
    if (rewardDeclined(cart)) return [];
    var spend = spendReward(cart);
    return [spend].filter(Boolean);
  }

  function reconcilePlan(cart, rewards) {
    var desiredByCampaign = {};
    rewards.forEach(function (reward) { desiredByCampaign[reward.campaign] = reward; });
    var kept = {};
    var updates = {};
    var additions = [];

    (cart.items || []).forEach(function (item) {
      var campaign = item.properties && item.properties[privateProperty];
      if (!campaign) return;
      var desired = desiredByCampaign[campaign];
      var isMatch = desired && Number(item.variant_id) === Number(desired.variantId) && !kept[campaign];
      if (isMatch) {
        kept[campaign] = true;
        if (Number(item.quantity) !== Number(desired.quantity)) updates[item.key] = desired.quantity;
      } else {
        updates[item.key] = 0;
      }
    });

    rewards.forEach(function (reward) {
      if (kept[reward.campaign]) return;
      additions.push({
        id: reward.variantId,
        quantity: reward.quantity,
        properties: {
          '_ns_gift_campaign': reward.campaign,
          '_ns_gift_tier': reward.tier,
          'Gift offer': reward.label
        }
      });
    });

    var changed = Object.keys(updates).length > 0 || additions.length > 0;

    return { updates: updates, additions: additions, changed: changed };
  }

  function applyPlan(plan) {
    var updateKeys = Object.keys(plan.updates);
    var sequence = Promise.resolve();
    if (updateKeys.length) {
      sequence = sequence.then(function () {
        return cartRequest('cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: plan.updates })
        });
      });
    }
    if (plan.additions.length) {
      sequence = sequence.then(function () {
        return cartRequest('cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: plan.additions })
        });
      });
    }
    return sequence;
  }

  function applyReconcileState(cart, plan, rewards) {
    var updateKeys = Object.keys(plan.updates);
    var codesChanged = !managedCodesMatch(cart, rewards);
    var previewMissing = config.previewBackend && (!cart.attributes || cart.attributes._ns_promotion_preview !== 'unified-v2');

    // Each tier has a dedicated gift pack variant. A tier change
    // needs an add request so its campaign properties stay attached. Prepare
    // the new discount while removing the old line, then add the new gift into
    // a cart where its zero-price discount is already active.
    if (plan.additions.length) {
      var preparation = Promise.resolve();
      if (updateKeys.length || codesChanged || previewMissing) {
        var preparationPayload = {};
        if (previewMissing) preparationPayload.attributes = {_ns_promotion_preview:'unified-v2'};
        if (updateKeys.length) preparationPayload.updates = plan.updates;
        if (codesChanged) preparationPayload.discount = mergedDiscountCodes(cart, rewards).join(',');
        preparation = cartRequest('cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(preparationPayload)
        });
      }
      return preparation
        .then(function () {
          return cartRequest('cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: plan.additions })
          });
        })
        .then(function () { return cartRequest('cart.js'); })
        .then(function (updatedCart) { return { cart: updatedCart, changed: true }; });
    }

    // Quantity corrections or removals and discount changes share one request.
    if (updateKeys.length || codesChanged || previewMissing) {
      var payload = {};
      if (previewMissing) payload.attributes = {_ns_promotion_preview:'unified-v2'};
      if (updateKeys.length) payload.updates = plan.updates;
      if (codesChanged) payload.discount = mergedDiscountCodes(cart, rewards).join(',');
      return cartRequest('cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (updatedCart) {
        if (updatedCart && Array.isArray(updatedCart.items)) return { cart: updatedCart, changed: true };
        return cartRequest('cart.js').then(function (freshCart) {
          return { cart: freshCart, changed: true };
        });
      });
    }

    if (!plan.changed && !codesChanged) return Promise.resolve({ cart: cart, changed: false });

    return Promise.resolve({ cart: cart, changed: false });
  }

  function confirmRewardPricing(cart, rewards) {
    if (!rewards.length || rewardLinesAreFree(cart, rewards)) return Promise.resolve(cart);
    return new Promise(function (resolve) { window.setTimeout(resolve, 90); })
      .then(function () { return cartRequest('cart.js'); });
  }

  function showPopup(cart, rewards) {
    if (!config.showPopup || document.querySelector('.ns-spend-shop') || !rewards.length || (config.productEntry && !productEntryEligible())) return;
    var key = 'ns_dueling_congrats:' + String(cart.token || 'cart') + ':' + rewards[0].signature;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (error) {}
    if (defaultCompactProgress() && !progressExplicitlyOpened) { progressClosed = true; setProgressVisibility(false); return; }
    progressClosed = false;
    setProgressVisibility(true);
    var panel = document.querySelector('[data-ns-gift-progress]');
    if (panel) {
      panel.classList.add('is-celebrating');
      window.setTimeout(function () { panel.classList.remove('is-celebrating'); }, 650);
    }
  }

  function refreshThemeCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    // The theme's cart:refresh only redraws the drawer, not /cart.
    var section = document.querySelector('.shopify-section--main-cart');
    if (!section || !section.id) return;
    var revision = ++cartViewRevision;
    var sectionId = section.id.replace(/^shopify-section-/, '');
    originalFetch(root() + 'cart?section_id=' + encodeURIComponent(sectionId))
      .then(function (response) { if (!response.ok) throw new Error('Cart view refresh failed.'); return response.text(); })
      .then(function (html) {
        if (revision !== cartViewRevision || !section.isConnected) return;
        var fragment = document.createElement('div');
        fragment.innerHTML = html;
        var replacement = fragment.querySelector('.shopify-section--main-cart');
        if (!replacement) return;
        var note = section.querySelector('[name="note"]');
        var nextNote = replacement.querySelector('[name="note"]');
        if (note && nextNote) nextNote.value = note.value;
        section.replaceChildren.apply(section, Array.from(replacement.childNodes));
      })
      .catch(function (error) { if (window.console) console.warn('[NS gift campaign]', error.message); });
  }

  function cartViewIsStale(cart) {
    var marker = document.querySelector('[data-ns-cart-snapshot]');
    if (!marker) return false;
    var snapshot = (cart.items || []).map(function (item) {
      return item.key + ':' + item.quantity + ':' + item.final_line_price;
    }).join('|');
    return marker.getAttribute('data-ns-cart-snapshot') !== snapshot;
  }

  // A concurrent add-on/cart writer can change Shopify line keys after our
  // read. Retry once from the new snapshot, never replay obsolete updates.
  function reconcileFreshCart(cart, rewards, attempt) {
    return applyReconcileState(cart, reconcilePlan(cart, rewards), rewards).catch(function (error) {
      if (attempt || !/updates parameter is invalid|no valid id|line item.*not found/i.test(error.message || '')) throw error;
      return cartRequest('cart.js').then(function (fresh) {
        var nextRewards = desiredRewards(fresh);
        return reconcileFreshCart(fresh, nextRewards, 1);
      });
    });
  }

  function waitForIdle(attempts) {
    if (!busy) return Promise.resolve();
    if (attempts <= 0) return Promise.reject(new Error('The cart is still updating. Please try Shop Pay again.'));
    return new Promise(function (resolve) { window.setTimeout(resolve, 80); })
      .then(function () { return waitForIdle(attempts - 1); });
  }

  function prepareFastCheckout(form) {
    return waitForIdle(60).then(function () {
      var checkoutToken = 'ns-shop-pay-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      var item = productFormItem(form || mainProductForm(), checkoutToken);
      var rewards = [];
      busy = true;
      queued = false;
      window.clearTimeout(timer);

      return cartRequest('cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function () { return cartRequest('cart.js'); })
        .then(function (cart) { return normalizePaidProtection(cart); })
        .then(function (cart) {
          rememberRewardCart(cart, true);
          renderProgress(cart, 'shop-pay');
          rewards = desiredRewards(cart);
          if (progressLevelFor(eligibleSpendSubtotal(cart)) > 0 && !rewards.length && !rewardDeclined(cart)) throw new Error('Your free gift is temporarily unavailable. Please contact us before checkout.');
          return applyReconcileState(cart, reconcilePlan(cart, rewards), rewards);
        })
        .then(function (result) {
          return confirmRewardPricing(result.cart, rewards);
        })
        .then(function (verifiedCart) {
          if (rewards.length && !rewardLinesAreFree(verifiedCart, rewards)) {
            throw new Error('The free gift could not be verified at $0, so checkout was stopped. Please try again.');
          }
          rememberRewardCart(verifiedCart, false);
          renderProgress(verifiedCart, 'shop-pay-ready');
          refreshThemeCart();
          return verifiedCart;
        })
        .catch(function (error) {
          return cartRequest('cart.js')
            .then(function (cart) { return removeFastCheckoutItem(cart, checkoutToken); })
            .then(function (cart) {
              var rollbackRewards = desiredRewards(cart);
              return applyReconcileState(cart, reconcilePlan(cart, rollbackRewards), rollbackRewards);
            })
            .then(function (result) { return confirmRewardPricing(result.cart, desiredRewards(result.cart)); })
            .catch(function () {})
            .then(function () { refreshThemeCart(); throw error; });
        })
        .finally(function () {
          busy = false;
          queued = false;
        });
    });
  }

  function reconcile(trigger, restore) {
    // Rebuy can emit events in background tabs. Only the visible storefront
    // should reconcile this shared cart; explicit restore/checkout is exempt.
    if (document.hidden && !restore) return Promise.resolve();
    if (busy) {
      queued = true;
      return;
    }
    busy = true;
    lastTrigger = trigger || lastTrigger;
    var rewards = [];
    var currentCart = null;

    return cartRequest('cart.js')
      .then(function (cart) { return normalizePaidProtection(cart); })
      .then(function (cart) {
        currentCart = cart;
        rememberRewardCart(cart, true);
        if (restore) {
          if (!spendReward(cart)) throw new Error('Your cart no longer qualifies for an available free gift.');
          rewardChoice.declined = false;
          rememberRewardCart(cart, false);
        }
        renderProgress(cart, lastTrigger);
        rewards = desiredRewards(cart);
        return reconcileFreshCart(cart, rewards, 0)
          .then(function (result) {
            rewards = desiredRewards(result.cart);
            return confirmRewardPricing(result.cart, rewards).then(function (verifiedCart) {
              result.cart = verifiedCart;
              return result;
            });
          });
      })
      .then(function (result) {
        if (!currentCart || !result || !result.cart) return;
        var updatedCart = result.cart;
        if (rewards.length && !rewardLinesAreFree(updatedCart, rewards)) {
          return removeCampaignRewardLines(updatedCart).then(function (safeCart) {
              rememberRewardCart(safeCart, false);
              renderProgress(safeCart, 'gift-discount-missing');
              refreshThemeCart();
              throw new Error('The preview gift discount did not reduce the reward line to zero, so the reward was removed to prevent a charge.');
          });
        }
        if (restore && (!spendReward(updatedCart) || spendReward(updatedCart).variantId !== rewards[0].variantId)) {
          throw new Error('Your cart changed. Please check your rewards and try again.');
        }
        rememberRewardCart(updatedCart, false);
        renderProgress(updatedCart, 'gift-update');
        if (result.changed || cartViewIsStale(updatedCart)) refreshThemeCart();
        if (result.changed) {
          showPopup(updatedCart, rewards);
        }
      })
      .catch(function (error) {
        if (window.console && console.warn) console.warn('[NS gift campaign]', error.message || error);
        if (restore) throw error;
      })
      .finally(function () {
        if (!restore) busy = false;
        if (queued && !restore) {
          queued = false;
          schedule('queued');
        }
      });
  }

  function restoreRemovedReward() {
    if (restoringReward) return Promise.resolve();
    var ownsBusy = false;
    restoringReward = true;
    restoreFeedback = '';
    if (latestCart) renderProgress(latestCart, 'restore-start');
    return waitForIdle(60).then(function () {
      if (busy) throw new Error('The cart is still updating. Please try again.');
      window.clearTimeout(timer);
      ownsBusy = true;
      return reconcile('restore-reward', true);
    }).catch(function (error) {
      restoreFeedback = 'We couldn’t restore your free gift. Please try again or contact us before checkout.';
      if (!ownsBusy) return;
      return cartRequest('cart.js').then(function (cart) {
        var reward = spendReward(cart);
        if (!reward || !rewardLinesAreFree(cart, [reward])) return removeCampaignRewardLines(cart);
        return cart;
      }).then(function (cart) {
        rememberRewardCart(cart, false);
        if (!rewardChoice.present) {
          rewardChoice.declined = true;
          try { sessionStorage.setItem('ns_dueling_reward_choice', JSON.stringify(rewardChoice)); } catch (storageError) {}
        } else {
          restoreFeedback = '';
        }
        latestCart = cart;
        refreshThemeCart();
      }).catch(function () {});
    }).finally(function () {
      restoringReward = false;
      if (ownsBusy) busy = false;
      if (latestCart) renderProgress(latestCart, 'restore-finished');
      var panel = document.querySelector('[data-ns-gift-progress]');
      var status = panel && panel.querySelector('[data-ns-gift-progress-status]');
      if (panel && !panel.hidden && status && typeof status.focus === 'function') status.focus({ preventScroll: true });
      if (ownsBusy && queued) { queued = false; schedule('restore-follow-up'); }
    });
  }

  function schedule(trigger) {
    lastTrigger = trigger || lastTrigger;
    window.clearTimeout(timer);
    timer = window.setTimeout(function () { reconcile(lastTrigger); }, 16);
  }

  document.addEventListener('cart:change', function (event) {
    var cart = event.detail && event.detail.cart;
    // Completed server response gives immediate progress feedback; the fresh
    // reconciliation read still verifies gift pricing before checkout.
    if (cart && Array.isArray(cart.items) && !busy) renderProgress(cart, 'cart:change');
    schedule('cart:change');
  });
  // Rebuy may use its own transport; reconcile from a fresh Shopify snapshot.
  document.addEventListener('rebuy:cart.change', function () { schedule('rebuy:cart.change'); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule('tab-visible'); });
  document.addEventListener('DOMContentLoaded', function () { schedule('dom-ready'); });
  document.addEventListener('DOMContentLoaded', function () { scheduleProductEntry(); });
  window.addEventListener('pageshow', function () { schedule('pageshow'); });
  window.addEventListener('pageshow', function () { scheduleProductEntry(); });
  document.addEventListener('variant:change', function () { scheduleProductEntry(); });
  document.addEventListener('product:rerender', function () { scheduleProductEntry(); });
  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest('[data-ns-gift-restore]')) {
      event.preventDefault();
      return restoreRemovedReward();
    }
    if (event.target && event.target.closest('[data-ns-gift-shop]')) {
      progressClosed = true;
      try { sessionStorage.setItem('ns_dueling_progress_closed', latestCart ? progressState(latestCart) : ''); } catch (error) {}
      setProgressVisibility(false);
      return;
    }
    if (event.target && event.target.closest('[data-ns-gift-progress-close]')) {
      progressClosed = true;
      progressExplicitlyOpened = false;
      closedCartState = latestCart ? progressState(latestCart) : '';
      try { sessionStorage.setItem('ns_dueling_progress_closed', closedCartState); } catch (error) {}
      setProgressVisibility(false);
      return;
    }
    if (event.target && event.target.closest('[data-ns-gift-progress-open]')) {
      progressClosed = false;
      progressExplicitlyOpened = true;
      try { sessionStorage.removeItem('ns_dueling_progress_closed'); } catch (error) {}
      setProgressVisibility(true);
      return;
    }

  });
  window.NSGiftCampaign = {
    fastCheckout: prepareFastCheckout
  };

  window.fetch = function () {
    var args = arguments;
    var requestUrl = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    return originalFetch.apply(window, args).then(function (response) {
      if (/\/cart\/(add|change|update|clear)\.js(?:\?|$)/.test(requestUrl)) schedule('cart-fetch');
      return response;
    });
  };
})();
